// C:\Users\cornn\source\repos\purehealthnexus\src\components\AiDashboard\AiMyNutritionStatus\AiUserMinerals.jsx
// Minerals are isolated here so the UI stays data-driven and backend-ready.

export const aiUserMinerals = [
  { id: 'mg', label: 'Mg',      percent: 70,  style: 'alert' },
  { id: 'fe', label: 'Iron',    percent: 95,  style: 'good'  },
  { id: 'na', label: 'Sodium',  percent: 110, style: 'over'  },
  { id: 'k',  label: 'K',       percent: 85,  style: 'good'  },
  { id: 'ca', label: 'Calcium', percent: 78,  style: 'warn'  },
];

export function mineralsChipText(list = aiUserMinerals, top = 2) {
  return list.slice(0, top).map((m) => `${m.label} ${m.percent}%`).join(' • ');
}
